import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconSend(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.433.71a.667.667 0 0 1 .878.8c-.005.02-.012.039-.019.059L10.63 14.888a.666.666 0 0 1-1.238.051L6.829 9.173 1.063 6.61a.666.666 0 0 1 .051-1.238zM12.13 2.929 3.141 6.075l4.045 1.798zM8.129 8.816l1.798 4.045 3.146-8.989z"
  }));
}
IconSend.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconSend.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconSend as default };
